import React, { useEffect, useState } from "react";
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import swal from "sweetalert";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#deal-of-the-day').DataTable({
      "destroy": true,
      "ajax": {
        url: `${baseUrl}product-lists`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        { data: 'id', name: 'id' },
        { data: 'product.name', name: 'product.name'},
        { data: 'date_from', name: 'date_from'},
        { data: 'date_to', name: 'date_to'},
        {
          data: 'actions',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-1 mt-1 edit"
                            row-id="${row.id}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                             <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.id}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>`;
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle(200).toggleClass("hidden-actions")
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteDealOfTheDay(id, name, table, $(this));
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/deal-of-the-day/${id}/edit`);
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  const deleteDealOfTheDay = (id, name, table, selector) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete Deal of the day ?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('product-lists/' + id, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }).then(function (res) {
          if (res.status == 200) {
            swal('The Deal of the day has been deleted!', {
              icon: "success",
            });
            deleteRow(table, selector);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  return (<>
    <div>
      <div className="d-flex flex-stack mb-5">
        <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
          <button type="button" className="btn btn-primary" data-bs-toggle="tooltip" title="Coming Soon"
                  onClick={() => navigate('/deal-of-the-day/create')}> Add Deal of the day
          </button>
        </div>
      </div>
      <table id="deal-of-the-day" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>ID</th>
          <th>Product</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  </>);
}